import React, {useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {changeReferralCode} from "../../../../actions/actionCreators";

const mapStateToProps = state => ({...state});

/**
 * This HOC will extract the referral code from url and put it in the input.
 * @returns {JSX.Element}
 * @constructor
 * @param WrappedComponent
 */
const referralWrapper = (WrappedComponent) => {

    const HOC = (props) => {
        const {
            match: {
                params: {
                    referralCode
                } = {}
            } = {},
            auth: {
                profile: {
                    share_code
                } = {}
            } = {}
        } = props


        useEffect(() => {

            if (referralCode)
                changeReferralCode(referralCode)
        }, [share_code])

        return (
            <WrappedComponent {...props} />
        );
    }

    return withRouter(connect(mapStateToProps)(HOC))
}
export default referralWrapper;